import { Component, Input, OnInit } from '@angular/core';

/**
 * Componente que muestra una flecha de retorno y navega a la ruta indicada en `path`.
 */
@Component({
  selector: 'app-arrow-back',
  templateUrl: './arrow-back.component.html',
  styles: [
    `
    .bi-arrow-90deg-left {
      cursor: pointer;
    }
    `
  ]
})
export class ArrowBackComponent implements OnInit {
  @Input() path: string = '';

  constructor() { }

  ngOnInit(): void {
  }

}
